export default "/images/34f8763b454e458e04af731e8f4a930c.jpg";